import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getApi } from "../../services/api";
import { apiEndPoints } from "../../config/path";
import { showError } from "../../helpers/messageHelper";

type frontImage = {
  image_url?: string;
};

type FetchCmsDataState = {
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  responseCode: number | null;
  responseData: frontImage;
};

const initialState: FetchCmsDataState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  responseCode: 0,
  responseData: {},
};

export const getPlans = createAsyncThunk(
  "/getPlans",
  async () => {
    try {
      const payload = await getApi(
        `${apiEndPoints.GET_PLANS}`
      );
      return payload;
    } catch (e: any) {
      showError(e.response.data.message);
      // return e;
    }
  }
);
export const getPlansSlice = createSlice({
  name: "getPlans",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPlans.pending, (state) => {
        state.isLoading = true;
      })
        .addCase(getPlans.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.responseCode = payload?.status;
        state.responseData = payload?.data?.data || {};
      })
      .addCase(getPlans.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

export const getPlansReducer = getPlansSlice.reducer;
